const category = document.querySelector('#category');
const form = document.querySelector('[data-industry-sources-form]');
if (category && form) {
    form.addEventListener('submit', (event) => {
        event.preventDefault();
        const idBranch = category.value;
        let paginationPath = category.dataset.paginationPathDefault;
        if (idBranch > 0) {
            paginationPath = category.dataset.paginationPathBranch.replace(/\/0\//, `/${ idBranch }/`);
        }
        window.location.replace(paginationPath);
    });
}
